// extracted by mini-css-extract-plugin
export default {"close-button":"TermAndCondition_close-button__2vEO4","content":"TermAndCondition_content__mK1Cr","title":"TermAndCondition_title__FCVMZ"};